import './styles.scss';

export default function initExternalLinks() {
  // Auto-appends an external link SVG icon to any anchor links that have valid
  // URLs. To prevent the icon from appearing, URLs (or portions of) can be
  // blacklisted by adding them to the `blacklist` array below.
  const blacklist = [
    '//delivering.vic.gov.au',
    '//racingintegrity.vic.gov.au',
    '//delivering.vic.gov.au',
    '.economicdevelopment.vic.gov.au',
    '//vic',
    '//twitter.',
    '//facebook.',
    '//defence.vic.gov.au',
  ];

  // Initial not selector value, to prevent .stretched-links being tampered with.
  let notSelector = ":not([class*='stretched-link'])";

  // Construct the :not() selector, based on the `blacklist` array.
  blacklist.forEach((url) => {
    notSelector = `${notSelector}:not([href*='${url}'])`;
  });

  const links = document.querySelectorAll(
    `.page-content a[href^='http']${notSelector}`
  ) as NodeListOf<HTMLAnchorElement>;

  links.forEach((link) => {
    link.insertAdjacentHTML(
      'beforeend',
      '<i class="fas fa-external-link-alt align-top ml-1" title="External link"></i>'
    );
  });
}
